import { render } from "./coursegrid-breadcrumb.vue?vue&type=template&id=be7d6944"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__